import React from "react";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import CardRequestsTable from "./components/CardStatementTable";
import PageHeader from "../../../shared/components/PageHeader";

const TransactionReport = () => (
    <Container>
        <PageHeader header="Get Transaction Report Statement" subheader="Generate a user's  transaction report statement" />
        <Row>
            <CardRequestsTable />
        </Row>
    </Container>
);

export default connect((state) => ({
    requests: state.getAllCardRequests,
}))(TransactionReport);
